import BaseApi from "../../BaseApi";

export default class AbsenceRequest extends BaseApi {

    construct() {}

    static getApiUrl() {
        return BaseApi.getApiVersionBasePath("v1") + "absence-requests/";
    }

    static managementUrl() {
        return BaseApi.getApiVersionBasePath("v1") + "absences/manage/";
    }

    static async create(payload){
        return this.post(this.getApiUrl(), payload);
    }

    static async index(filters = {}) {
        return this.get(this.getApiUrl() , filters);
    }

    static async all(filters = {}, requestConfig = {}) {
        return this.index({
            ...requestConfig,
            params: filters,
        });
    }

    static async update(id, payload) {
        return this.patch(this.getApiUrl() + id, payload);
    }

    static async delete(id, payload = {}) {
        return this.getAxiosInstance().delete(this.getApiUrl() + id, {
            data: payload,
        });
    }

    static async show(id) {
        return this.get(this.getApiUrl() + id);
    }

    static async statuses() {
        return this.get(this.getApiUrl() + "statuses");
    }

    static async history(id) {
        return this.get(this.getApiUrl() + id + "/history");
    }

    static async approve(id, payload) {
        return this.post(
            this.getApiUrl() + "department-responsible/" + id + "/approve",
            payload,
        );
    }

    static async cancel(id, payload) {
        return this.post(
            this.getApiUrl() + "department-responsible/" + id + "/cancel",
            payload,
        );
    }

    static async reject(id, payload) {
        return this.post(
            this.getApiUrl() + "department-responsible/" + id + "/reject",
            payload,
        );
    }

    static async deny(id, payload) {
        return this.reject(id, payload);
    }

    static async process(id, payload = {}) {
        return this.post(
            this.getApiUrl() + "human-resources/" + id + "/process",
            payload,
        );
    }

    static async getUsers(filters = {}) {
        return this.get(
            `${this.getApiUrl()}manage/get-users`,
            filters,
        );
    }

    static async listDefaultDays(filters = {}) {
        return this.get(
            `${this.managementUrl()}list-default-days`,
            filters,
        );
    }

    static async exportVacationMap(filters = {}) {
        return this.getAxiosInstance().get(this.getApiUrl() + "export", {
            params: filters,
            responseType: "blob",
        });
    }
}
